module.exports = __webpack_public_path__ + "static/media/backimage_.d9b241f5.png";